// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { Base64 } from '../../../utils/base64';
import type { ExcludeMethodsDeep } from '../../../utils/types';

export class GeneratedPDF {
  readonly pdf: Base64;

  constructor(data: { [key: string]: any } = {}) {
    this.pdf = data.pdf === undefined ? '' : data.pdf;
  }

  static zero(): GeneratedPDF {
    const zeroValues: ExcludeMethodsDeep<GeneratedPDF> = {
      pdf: '',
    };
    return new GeneratedPDF(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type GeneratedPDFWireFormat = {
  pdf: string;
};

type NewGeneratedPDFProps = PartialDeep<GeneratedPDF, { recurseIntoArrays: true }>;
export const NewGeneratedPDF: (props: NewGeneratedPDFProps) => GeneratedPDF = (props) =>
  new GeneratedPDF(props);

type NewGeneratedPDFFromWireFormatProps = PartialDeep<
  GeneratedPDFWireFormat,
  { recurseIntoArrays: true }
>;
export const NewGeneratedPDFFromWireFormat: (
  props: NewGeneratedPDFFromWireFormatProps,
) => GeneratedPDF = (props) => new GeneratedPDF(props);
